@if(isReady) {
<idp-flyout-search
  (searchValue)="this.terms$.next($event)"
  [displayFlyout]="displayFlyout"
  [content]="(flyoutContent$ | ngrxPush) || emptyFlyoutContent"
  (submitTerm)="submitSearch($event)"
  (closeFlyoutSearch)="closeFlyout()"
  (selectValue)="updateAnalytics($event)"
  [footerFlyoutSearch]="displayFooterSearch"
></idp-flyout-search>
} @else {
<div class="flex justify-center items-center">
  <span class="component-loader"></span>
</div>
}
